module.exports = __webpack_public_path__ + "images/emails/page-t-39fded01.gif";